// src/components/modals/TermsModal.js
import React from 'react';
import ReactDOM from 'react-dom'; // Import ReactDOM for creating portals

const TermsModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return ReactDOM.createPortal(
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="font-free-text bg-white p-6 rounded-lg w-full max-w-lg h-[80vh] overflow-y-auto text-left">
        <h1 className="text-xl font-headers font-bold mb-4">Terms of Use & Privacy Policy</h1>

        <h2 className="text-lg font-headers font-semibold mt-4">Introduction</h2>
        <p className="text-sm mt-2">
          Waybee.ai is an AI-powered travel companion with knowledge of cities that evolves and improves over time. While we strive to provide accurate and useful information, it is important to note that Waybee can sometimes be inaccurate or misleading due to the inherent nature and limitations of AI technology.
        </p>
        <p className="text-sm mt-2 uppercase">
          We recommend using the information provided responsibly and always double-checking critical details.
        </p>
        <h2 className="text-lg font-headers font-semibold mt-4">Terms & Conditions</h2>
        <p className="text-sm mt-2">
          By using Waybee.ai, you agree to the following terms and conditions. 
        </p>
        <p className="text-sm mt-2">
          Waybee.ai is an AI-based travel companion ("Service"). While we strive to ensure the accuracy of the information provided, we cannot guarantee it will be error-free or current. The Service is provided "as is," without any warranties, express or implied.
        </p>
        <p className="text-sm mt-2">
          You acknowledge that using the Service is at your own risk. Waybee.ai, its developers, and affiliated parties are not liable for any direct, indirect, incidental, special, or consequential damages arising from the use or inability to use the Service, even if advised of the possibility of such damages. This includes, but is not limited to, data loss, loss of profits, or other losses incurred.
        </p>
        <p className="text-sm mt-2">
          Users are responsible for verifying that the information provided by Waybee.ai meets their needs and should exercise appropriate caution, particularly while traveling. Respectful use of the Service is expected, and misuse or interference with its operation is prohibited.
        </p>
        <p className="text-sm mt-2">
          Waybee.ai reserves the right to modify these terms at any time. By continuing to use Waybee.ai, you accept any modifications to these terms.
        </p>
        <p className="text-sm mt-2 uppercase">
          If you do not agree to these terms, please do not use the Service.
        </p>
        <h2 className="text-lg font-headers font-semibold mt-4">Privacy Policy</h2>
        <p className="text-sm mt-2">
          Waybee.ai respects your privacy and is committed to protecting your personal data. This policy outlines how we collect, use, and store your information.
        </p>
        <p className="text-sm mt-2">
          We collect personal information such as your location, preferences, and interactions with the app to improve the quality of our recommendations and provide you with a personalized experience. We do not share your personal information with third parties without your explicit consent, except where required by law.
        </p>
        <p className="text-sm mt-2">
          We implement industry-standard security measures to protect your data, but please note that no system is completely secure. By using Waybee.ai, you acknowledge and accept the potential risks involved in sharing your personal information online.
        </p>
        <p className="text-sm mt-2">
          Users have the right to access, correct, or delete their personal data. You may reach out to us at <a href="mailto:support@waybee.ai" className="text-blue-500">support@waybee.ai</a>.
        </p>

        <button
          onClick={onClose}
          className="mt-4 w-full bg-gray-700 text-white py-2 rounded hover:bg-gray-800"
        >
          Close
        </button>
      </div>
    </div>,
    document.body // Render the modal directly into the body
  );
};

export default TermsModal;
